var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.877,
    height: 26,
    viewBox: "0 0 17.877 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lightbulb",
    d: "M20.881,23.084a1.627,1.627,0,0,0,.268.9l.87,1.3a1.816,1.816,0,0,0,1.353.725H26.5a1.815,1.815,0,0,0,1.351-.725l.867-1.3a1.914,1.914,0,0,0,.272-.9L29,21.093H20.875ZM24.908.012a8.9,8.9,0,0,0-6.7,14.773,14.609,14.609,0,0,1,2.652,4.644c0,.013,0,.026.006.04h8.136c0-.013,0-.026.006-.04a14.6,14.6,0,0,1,2.652-4.644A8.71,8.71,0,0,0,33.877,8.9,8.929,8.929,0,0,0,24.908.012Zm.03,4.875A4.058,4.058,0,0,0,20.875,8.9a.826.826,0,0,1-.813.858.815.815,0,0,1-.813-.813,5.656,5.656,0,0,1,5.688-5.642.812.812,0,0,1,.813.813A.776.776,0,0,1,24.938,4.888Z",
    transform: "translate(-16 -0.012)",
    fill: "#556ee6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.8718f946.svg";
export { ForwardRef as ReactComponent };